import { NotificationContainer } from "components/NotificationsCenter/components/ClaireNotification/components/NotificationContainer";

import type { NotificationRegistryConfig } from "components/NotificationsCenter/components";

type AppointmentUpdateNotificationProps = {
  icon: string;
  title?: string;
  description?: string;
  closeToast: () => void;
};

export const AppointmentUpdateNotification = ({ closeToast, icon, title, description }: AppointmentUpdateNotificationProps) => (
  <NotificationContainer icon={icon} title={title} description={description} onCloseNotification={closeToast} />
);

export const AppointmentUpdateNotificationConfig: NotificationRegistryConfig = {
  toastOptions: { style: { width: "450px", right: "130px" } },
  render: ({ closeToast, title, description, icon }) => <AppointmentUpdateNotification icon={icon} title={title} description={description} closeToast={closeToast} />
};
